import { HistoryLogActions } from "src/modules/data-protection/constants";

const ACTIVITY_ACTION_FALLBACKS = {
    software: {
        data_protection_impact_assessment_completed: "DPIA completed",
        approval_requirement_approved: "Software approval requirement approved"
    },
    document: {
        document_added: "Document added",
        document_updated: "Document updated",
        document_removed: "Document removed"
    }
};

export const getActivityLabel = (item) => {
    const section = item?.section;
    const action = item?.action;
    const mapped =
        HistoryLogActions[section]?.[action] ||
        ACTIVITY_ACTION_FALLBACKS[section]?.[action];

    if (mapped) {
        return mapped;
    }

    return action || section || "Activity";
};
